var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useEffect, useState } from 'react';
import { createRenderTarget, removeRenderTarget } from '../helpers/renderTarget';
export function useRenderTarget(_a) {
    var { id, cleanup = false } = _a, attributes = __rest(_a, ["id", "cleanup"]);
    const [renderTarget, setRenderTarget] = useState(createRenderTarget({ id, attributes }));
    useEffect(() => {
        if (renderTarget === null) {
            setRenderTarget(createRenderTarget({ id, attributes }));
        }
    }, [renderTarget, id, attributes]);
    useEffect(() => {
        return () => {
            if (cleanup) {
                removeRenderTarget(id);
            }
        };
    }, [cleanup, id]);
    return renderTarget;
}
//# sourceMappingURL=useRenderTarget.js.map